import { DashboardRemove } from "./model/DashboardRemove";
var DashboardRemoveStore = new DashboardRemove();
export { DashboardRemoveStore };
